import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';
import moment from 'moment'

const Receita = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchReceitas()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Arrecadação nº {props.receita._id}</Card.Title>
                        <p>Fonte: {props.receita.fonte}</p>
                        <p>Data: {moment(props.receita.data).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</p>
                        <p>Valor: {props.receita.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                        <p>Descrição: {props.receita.descricao}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.receita._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.receita._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Receita;